webpackJsonp([276515772795592],{

/***/ 1332:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"VisitType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"AMBULATORY"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"BOARDING"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"E_CONSULT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"EMERGENCY"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"FIELD_SERVICE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"IN_PATIENT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"MEDICAL_BOARDING"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"OUT_PATIENT"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-visit-type-9234c23302bcf9ca3f86.js